export default __webpack_public_path__ + "static/media/depature.0a406693.jpg";